'use client';

import { useEffect } from 'react';

export default function CalendlyWidget() {
  useEffect(() => {
    let scriptLoaded = false;

    const loadCalendlyScript = () => {
      if (
        document.querySelector(
          'script[src="https://assets.calendly.com/assets/external/widget.js"]'
        )
      ) {
        initWidget();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.onload = () => {
        scriptLoaded = true;
        initWidget();
      };
      document.body.appendChild(script);
    };

    const initWidget = () => {
      if (typeof window !== 'undefined' && (window as any).Calendly) {
        const calendlyWidget = document.querySelector('.calendly-inline-widget');
        if (calendlyWidget) {
          calendlyWidget.innerHTML = ''; // Clear previous content if any
          (window as any).Calendly.initInlineWidget({
            url: 'https://calendly.com/zappingai/30min?hide_landing_page_details=1&hide_gdpr_banner=1',
            parentElement: calendlyWidget,
          });
        }
      } else if (!scriptLoaded) {
        // If called before script load (shouldn't happen with this logic, but safety first), retry after delay
        setTimeout(initWidget, 100);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadCalendlyScript();
            observer.disconnect();
          }
        });
      },
      { rootMargin: '200px' }
    );

    const widget = document.querySelector('.calendly-inline-widget');
    if (widget) observer.observe(widget);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="calendly-inline-widget"
      data-url="https://calendly.com/zappingai/30min?hide_landing_page_details=1&hide_gdpr_banner=1"
      style={{
        minWidth: '320px',
        height: '700px',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
      suppressHydrationWarning={true}
    />
  );
}
